import * as React from 'react';
import * as d3 from 'd3';
import { observer } from 'mobx-react';
import { ICirclePointDiagramParams } from './ICirclePointDiagramParams';

@observer
export class CirclePointDiagram extends React.Component<ICirclePointDiagramParams> {
  private pointsPathNode: SVGPathElement;

  constructor(props: ICirclePointDiagramParams) {
    super(props, undefined);
  }

  componentDidMount() {
    if (!this.props.combineScore) return;

    var innerRadiusPoints = 75;
    var outerRadiusPoints = 93;

    var pointsArc = d3.svg
      .arc()
      .innerRadius(innerRadiusPoints)
      .outerRadius(outerRadiusPoints)
      .startAngle(0) as any;

    var tau = 2 * Math.PI; // http://tauday.com/tau-manifesto
    function arcTween(newAngle: any) {
      return function(d: any) {
        var interpolate = d3.interpolate(d.endAngle, newAngle);

        return function(t: any) {
          d.endAngle = interpolate(t);
          return pointsArc(d);
        };
      };
    }

    var foreground = d3.select(this.pointsPathNode);
    foreground.datum({ endAngle: 0 }).attr('d', pointsArc);

    foreground
      .transition()
      .duration(750)
      .attrTween('d', arcTween((this.props.combineScore / 100) * tau));
  }

  render() {
    //Margins
    var marginTop = 23;
    var marginBottom = 20;
    var marginRight = 80;
    var marginLeft = 80;

    //SVG dimensions
    var svgWidthWithMargins = 359;
    var svgHeightWithMargins = 245;

    //Margins and dimensions
    var margin = { top: marginTop, right: marginRight, bottom: marginBottom, left: marginLeft },
      width = svgWidthWithMargins - margin.left - margin.right,
      height = svgHeightWithMargins - margin.top - margin.bottom;

    var innerRadius = 78;
    var outerRadius = 90;
    //var innerRadiusPoints = 75;
    var outerRadiusPoints = 93;

    var ringArc = d3.svg
      .arc()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius)
      .startAngle(0 * (Math.PI / 180)) //converting from degs to radians
      .endAngle(360 * (Math.PI / 180)) as any;

    var ringContainerTransform = 'translate(' + outerRadiusPoints + ',' + outerRadiusPoints + ')';
    var pointsTransform = 'translate(' + outerRadiusPoints + ',' + outerRadiusPoints + ')';

    return (
      <div className={this.props.className}>
        <svg className="svgContainer" width={svgWidthWithMargins} height={svgHeightWithMargins}>
          <g></g>

          {this.props.combineScore != null ? (
            <g
              className="background-group"
              transform={'translate(' + margin.left + ',' + margin.top + ')'}
            >
              <svg className="ringContainer" width={width} height={height}>
                <path
                  d={ringArc()}
                  height={height}
                  fill="#E5E6E7"
                  transform={ringContainerTransform}
                />
              </svg>
              <svg className="ring-container" width={width} height={height}>
                <path
                  height={height}
                  fill="#EC691A"
                  transform={pointsTransform}
                  ref={(elem: SVGPathElement) => {
                    this.pointsPathNode = elem;
                  }}
                />
                <text className="combineScoreText" x={outerRadiusPoints} y={outerRadiusPoints + 20}>
                  {this.props.combineScore.toFixed(1)}
                </text>
              </svg>
            </g>
          ) : (
            ''
          )}
        </svg>
      </div>
    );
  }
}
